import { useAssessmentViewContext } from "@features/assessments-feature/contexts-providers/AssessmentViewContextProvider";
import { Box } from "@mui/material";
import { CapabilityChangesReusableComponent } from "../assessment-widgets/CapabilityChangesWidget";

export const AssessmentOverviewCapabilityChanges = () => {
  const { program: programString } = useAssessmentViewContext();
  const widgetNoSubheader = {
    title: "Capability Changes",
    widgetGroup: "",
    widgetId: "capability-changes",
    enabled: true,
  };

  return (
    <Box paddingBottom={10}>
      <CapabilityChangesReusableComponent
        programString={programString}
        widgetNoSubheader={widgetNoSubheader as any}
        height="auto"
      />
    </Box>
  );
};
